export default "__VITE_ASSET__KTlv7RM$__"